import enhance from './container';
import GoogleMapsLink from './component';

export default enhance(GoogleMapsLink);
